import React from 'react'
import ReactModal from 'react-modal'
import { FilePlus2 } from 'lucide-react'

// Client clicked "Find a law firm" with no published case yet.
function NoCases({uploadNew, onClose, onSubmit}) {
  return (
    <ReactModal
    shouldCloseOnEsc = {true}
    shouldCloseOnOverlayClick = {true}
    onRequestClose={onClose}
    isOpen = {uploadNew}
    style={{
        overlay: { zIndex: 30, backgroundColor: 'rgba(20,33,61,.45)' },
        content: {
            height: 'auto', width: 'calc(100vw - 32px)', maxWidth: '420px',
            top: '50%', left: '50%', right: 'auto', bottom: 'auto', marginRight: '-50%', transform: 'translate(-50%, -50%)',
            padding: '28px 24px 24px', border: '1px solid rgba(20,33,61,.12)', borderRadius: '8px',
            backgroundColor: '#fffdf8', boxShadow: '0 16px 40px rgba(20,33,61,.3)',
        }
      }}
    >
        <div className='flex flex-col items-center text-center font-plexsans'>
            <div className='flex items-center justify-center rounded-full mb-4 w-12 h-12 bg-brass/[.1] text-brass'>
                <FilePlus2 size={21} strokeWidth={1.8}/>
            </div>
            <div className='font-spectral font-medium text-[20px] leading-[1.3] text-navy mb-2'>Post your case first</div>
            <p className='m-0 text-[13.5px] leading-[1.6] text-navy/[.6]'>
                Law firms are matched to the details of your case. Once your case is posted, you can review matching firms and pre-approve them to view it.
            </p>
            <div className='flex flex-col-reverse sm:flex-row w-full gap-2.5 mt-6'>
                <button type='button' onClick={onClose}
                className='w-full sm:flex-1 h-11 min-h-[44px] flex-none rounded-md cursor-pointer font-semibold text-[13.5px] leading-none text-navy bg-white border border-navy/[.2] hover:bg-navy/[.04]'>
                    Not now
                </button>
                <button type='button' onClick={onSubmit}
                className='w-full sm:flex-1 h-11 min-h-[44px] flex-none rounded-md cursor-pointer font-semibold text-[13.5px] leading-none text-ivory bg-brass border-0 hover:bg-brassDark'>
                    Create a case
                </button>
            </div>
         </div>
    </ReactModal>
  )
}


export default NoCases
